import { FileText, CalendarCheck, Sparkles } from "lucide-react";

const steps = [
  { icon: FileText, num: "1", title: "Get a Quote", desc: "Tell us what cleaning service you need." },
  { icon: CalendarCheck, num: "2", title: "Book Your Service", desc: "Choose a time that suits you." },
  { icon: Sparkles, num: "3", title: "We Get It Done", desc: "Our team arrives and completes the job professionally." },
];

const HowItWorks = () => (
  <section id="how-it-works" className="bg-white py-16 md:py-24">
    <div className="container">
      <h2 className="text-3xl md:text-4xl font-black text-[#111111] text-center mb-4">
        How It Works
      </h2>
      <p className="text-center text-[#111111]/70 mb-14 max-w-lg mx-auto">
        Three simple steps to a cleaner space.
      </p>
      <div className="grid md:grid-cols-3 gap-10 max-w-4xl mx-auto">
        {steps.map((s) => (
          <div key={s.num} className="text-center">
            <div className="w-20 h-20 bg-[#FFD400] rounded-full flex items-center justify-center mx-auto mb-5 shadow-[0_8px_24px_rgba(255,212,0,0.35)] transition-transform hover:scale-105">
              <s.icon className="w-9 h-9 text-[#111111]" />
            </div>
            <h3 className="text-xl font-bold text-[#111111] mb-2">{s.title}</h3>
            <p className="text-[#111111]/70 leading-relaxed">{s.desc}</p>
          </div>
        ))}
      </div>
      <div className="mt-12 text-center">
        <a
          href="#quote"
          className="inline-block bg-[#0066FF] text-white px-8 py-4 text-lg font-bold rounded-md hover:bg-[#0066FF]/90 transition-colors shadow-[0_4px_14px_rgba(0,102,255,0.3)]"
        >
          Get Started - It's Free
        </a>
      </div>
    </div>
  </section>
);

export default HowItWorks;
